// tslint:disable variable-name
import { injectable } from '~/container'
import { FullHierarchy, Hierarchy } from './types'

@injectable()
export abstract class HierarchyReadRepository {
  abstract getAncestors(path: string, langCode: string): Promise<Hierarchy[]>
  abstract getChildren(path: string, langCode: string): Promise<Hierarchy[]>
  abstract getCountries(langCode: string): Promise<Hierarchy[]>
  abstract getFullHierarchy(
    path: string,
    langCode: string,
  ): Promise<FullHierarchy>
  abstract getHierarchyWithBookableOnly(
    path: string,
    langCode: string,
  ): Promise<FullHierarchy>
  abstract readOneByPath(path: string, langCode: string): Promise<Hierarchy>
}
